import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import Divider from '@material-ui/core/Divider';

import { styled } from '@this/constants/themes';
import { isAiTravel, isProduction } from '@this/src/util';
import Context from '@this/components/core_app/core_app_context';
import FormattedKeyValue from '@this/shared/formatted_key_value/formatted_key_value';
import type { FreeeExternalProps } from './freee/freee_external';
import FreeeExternal from './freee/freee_external';
import type { InfomartExternalProps } from './infomart/infomart_external';
import InfomartExternal from './infomart/infomart_external';
import BugyoExternal from './bugyo/bugyo_external';

type Props = FreeeExternalProps & InfomartExternalProps & { bugyoConnected: boolean };

const External = ({ freeeConnected, bugyoConnected, infomartConnected, invoice, onRefreshInvoices }: Props) => {
  const { serviceId } = useContext(Context);
  return (
    <div>
      <p>請求書を外部サービスと連携することができます。</p>
      <Info>
        <FormattedKeyValue
          data={[
            { key: '対象期間', value: invoice.from && invoice.from.format('YYYY年MM月分') },
            { key: '請求日', value: invoice.chargedAt.format('YYYY/MM/DD') },
            { key: '合計金額', value: utils.formatPriceWithMark(invoice.totalPriceWithTax) },
            { key: 'お支払い期限', value: invoice.payAt.format('YYYY/MM/DD') }
          ]}
        />
      </Info>
      <div>
        <H2>freee連携</H2>
        <FreeeExternal freeeConnected={freeeConnected} invoice={invoice} />
      </div>
      {!isProduction() && isAiTravel(serviceId) && (
        <>
          <Divider style={{ marginTop: '20px' }} />
          <div>
            <H2>勘定奉行連携</H2>
            <BugyoExternal bugyoConnected={bugyoConnected} invoice={invoice} />
          </div>
        </>
      )}
      {infomartConnected && (
        <>
          <Divider style={{ marginTop: '20px' }} />
          <div>
            <InfomartExternal
              infomartConnected={infomartConnected}
              invoice={invoice}
              onRefreshInvoices={onRefreshInvoices}
            />
          </div>
        </>
      )}
    </div>
  );
};

const Info = styled.div`
  margin-top: 10px;
  font-size: 12px;
  background: #ddd;
  padding: 5px;
  width: fit-content;
`;

const H2 = styled.h2`
  margin-top: 20px;
`;

export default observer(External);
